module.exports = __webpack_public_path__ + "static/stamp-f0be6a46f99bef0af3943a97291079de.jpg";